import { type AxiosError } from 'axios';
import { microServicesRoutes } from '@constants';
import { type SafeUserDto, type ApiResponse } from '@types';
import { edgeApi } from '@lib/apiClients';

export const getUser = async (
  userId: string,
): Promise<ApiResponse<SafeUserDto>> => {
  try {
    const url = `${microServicesRoutes.edge.get.users.userNest}/${userId}`;
    const response = await edgeApi.get<SafeUserDto>(url);

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    const error = err as AxiosError<{ message?: string }>;
    const status = error.response?.status ?? 500;
    const message =
      error.response?.data?.message ?? 'Error getting the requested user';

    return {
      success: false,
      status,
      error: {
        message,
        status,
        raw: error,
      },
    };
  }
};
